module.exports = __webpack_public_path__ + "static/media/galleryImg5.fd81a2cb.jpg";